import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Skeleton from '@pedidosya/web-fenix/system/Skeleton';
import Card from '@components/CardContainer';

const CardShimmer = styled(Card)`
  width: fit-content;
  padding: 12px;
  ${({ isDesktopLayout }) =>
    isDesktopLayout
      ? css`
          margin: ${({ theme }) => theme.spacing(0)};
        `
      : css`
          margin: ${({ theme }) => theme.spacing(0, 0, 8, 0)};
        `};
`;

const Content = styled.div`
  width: 75%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};
`;

const Image = styled.div`
  width: 25%;
`;

const TitleShimmer = styled(Skeleton)`
  margin-bottom: ${({ theme }) => theme.spacing(7)};
`;

const ProductCardShimmer = ({ isDesktopLayout }) => (
  <CardShimmer isDesktopLayout={isDesktopLayout}>
    <Image>
      <Skeleton height="19" width="19" />
    </Image>
    <Content>
      <TitleShimmer height="12" width="60" />
      <Skeleton height="12" width="60" />
      <Skeleton height="12" width="30" />
    </Content>
  </CardShimmer>
);

ProductCardShimmer.propTypes = {
  isDesktopLayout: PropTypes.bool,
};

ProductCardShimmer.defaultProps = {
  isDesktopLayout: false,
};

export default memo(ProductCardShimmer);
